module.exports = __webpack_public_path__ + "static/media/google.1efd614a.svg";